import React from 'react';

import { ButtonTheme } from '@imgly/imgly-website-components';

import { ReactComponent as ExternalLinkIcon } from '../../assets/images/icons/ExternalLink.svg';
import { Links } from '../../utils/constants';
import { LinkButton } from '../LinkButton';

import * as classes from './style.module.scss';

export const NavigationBottomControls: React.FC = () => {
  return (
    <div className={classes.root}>
      <div className={classes.first}>
        <LinkButton
          className={classes.button}
          href={Links.ContactSales.url}
          theme={ButtonTheme.Secondary}
          small
          trailingIcon={<ExternalLinkIcon />}
        >
          {Links.ContactSales.name}
        </LinkButton>
        <LinkButton
          className={classes.button}
          href={Links.FreeTrial.url}
          theme={ButtonTheme.Primary}
          small
          trailingIcon={<ExternalLinkIcon />}
        >
          {Links.FreeTrial.name}
        </LinkButton>
      </div>
      <div className={classes.second}>
        <LinkButton
          href="https://img.ly"
          theme={ButtonTheme.Text}
          small
          leadingIcon={<ExternalLinkIcon />}
        >
          IMG.LY Main Site
        </LinkButton>
      </div>
    </div>
  );
};
